import type {
  FederationRatings,
  UserPrivateProfile,
  UserPublicProfile,
} from "@/pages/profile/api";

export function initialsForUsername(username: string) {
  return username.slice(0, 2).toUpperCase();
}

export function formatRatingLabel(value: number | null | undefined, label: string) {
  if (typeof value !== "number" || value <= 0) {
    return null;
  }
  return `${label} ${value}`;
}

export function profileIdentityChips(profile: UserPublicProfile | UserPrivateProfile) {
  const federationRatings = federationEntries(profile.federation_ratings).map(
    ([label, value]) => `${label} ${value}`,
  );
  return [
    profile.title?.trim() || null,
    formatRatingLabel(profile.fide_rating, "FIDE"),
    profile.china_title?.trim() || null,
    ...federationRatings,
  ].filter((item): item is string => Boolean(item));
}

export function federationEntries(ratings: FederationRatings | null | undefined) {
  const safeRatings = ratings ?? {};
  return [
    ["USCF", safeRatings.uscf],
    ["CFC", safeRatings.cfc],
    ["ECF", safeRatings.ecf],
    ["DSB", safeRatings.dsb],
    ["RCF", safeRatings.rcf],
  ].filter((entry): entry is [string, number] => typeof entry[1] === "number");
}
